export const now =
  typeof performance === 'object' ? () => performance.now() : Date.now;
